import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Hide, Image, Stack, Text, useBreakpointValue, VStack } from '@chakra-ui/react'
import { usePayment } from 'context'
import { PaymentSubscriptionType } from 'context/Payment'
import { themeColors } from 'theme'

import { CardContainer } from 'components/CustomCard'
import CustomDivider from 'components/CustomDivider'
import PlanItems from 'components/PlanItems'
import { DecreaseIcon, IncreaseIcon } from 'components/SVGS'
import formatter from 'utils/helpers/formatter'

type HireWicarRouterProps = { subscription: PaymentSubscriptionType }

export const HireWicar = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const breakpoint = useBreakpointValue({ base: 'small', md: 'desktop', lg: 'large' })

  const { paymentState: { state: { isPaidInstallation,
    paymentOptions: { data: { anualPayment, firstPayment, installation } }
  } } } = usePayment()

  const [isOpen, setIsOpen] = useState(false)
  const [subscription, setSubscription] = useState<PaymentSubscriptionType | null>(null)

  const { text: { smallText } } = themeColors

  useEffect(() => {
    let subscription = null

    if (location.state) ({ subscription } = location.state as HireWicarRouterProps)
    setSubscription(subscription)
  }, [location])

  const handleNavigation = () => {
    navigate('/subscription-info', { state: { subscription } })
  }

  return (
    <CardContainer isScreen headerText='Suscripción premium' >
      <Stack direction={{ base: 'column', lg: 'row' }} w='full' h='full' alignItems='center' spacing={4}>
        <VStack justifyContent='center' alignItems='flex-start' w={{ base: 'full', lg: '50%' }} h='full'>
          <Image src='svg/icons/wicar-app.png' maxW='400px' w='full' h='full' mx='auto' />
          {subscription?.subscriptionType === 'SUSCR-RENOV'
            ? <Text variant='MD_SB'>
              Precio anual {formatter.format(parseInt(anualPayment.amount ?? '120000'))}
            </Text>
            : <>
              <Text variant='MD_SB'>
                Primer año {formatter.format(
                  parseInt((isPaidInstallation ? installation.amount : firstPayment.amount) ?? '319990')
                )}
              </Text>
              <Text variant='MD'>
                Renovación segundo año {formatter.format(parseInt(anualPayment.amount ?? '120000'))} (IVA incluido)
              </Text>
            </>
          }
        </VStack>
        <Hide below='lg'>
          <CustomDivider orientation mr={10} />
        </Hide>
        <VStack alignItems='flex-start' w={{ base: 'full', lg: '50%' }} h='full' spacing={4}>
          <Hide above='lg'>
            <Button
              variant='link'
              fontSize='sm'
              w='full'
              justifyContent='flex-start'
              textTransform='capitalize'
              onClick={() => setIsOpen(!isOpen)}
              leftIcon={!isOpen
                ? <IncreaseIcon size={8} secondFill='black' />
                : <DecreaseIcon size={8} secondFill='black' />
              }>
              Lo que incluye la suscripción
            </Button>
          </Hide>
          <VStack hidden={(breakpoint !== 'large' && !isOpen)} alignItems='flex-start' h='full' spacing={2}>
            <Text color={smallText}>Lo que incluye</Text>
            <PlanItems isPremium />
          </VStack>
          <Button w='full' maxW={{ xl: '60%' }} whiteSpace='initial' onClick={handleNavigation}>
            {
              subscription?.subscriptionType === 'SUSCR-RENOV'
                ? `renovar por ${formatter.format(parseInt(anualPayment.amount ?? '120000'))}`
                : `contratar por ${formatter.format(
                  parseInt((isPaidInstallation ? installation.amount : firstPayment.amount) ?? '319990')
                )}`
            }
          </Button>
        </VStack>
      </Stack>
    </CardContainer>
  )
}
